const en = {
  siteName: "Mounir El Majdoub",
  jobTitle: "Web Master & Fullstack Developer",
  nav: { index: "index", work: "work", about: "about", contact: "contact" },
  home: {
    name1: "Mounir",
    name2: "El Majdoub",
    role1: "Web Master",
    role2: "& Developer",
    basedIn: "based in",
    casablanca: "casablanca, ma",
    availableFor: "available for",
    freelanceWork: "freelance work",
    selectedWork: "(selected work)",
    viewAllWork: "view all work",
    aboutLabel: "(about)",
    aboutTeaser:
      "I'm Mounir El Majdoub, a web master and fullstack developer based in Casablanca. I design and build fast, refined websites and web applications, from real-estate and corporate platforms to brand and event sites, handling everything from front-end craft to back-end delivery.",
    email: "email",
    linkedin: "linkedin",
    instagram: "instagram",
    copy: "© 2026",
    footerName: "mounir el majdoub",
    footerTitle: "web master & fullstack developer",
    footerBased: "casablanca",
  },
  stack: {
    label: "(stack)",
    development: "(development)",
    ai: "(ai)",
    note: "favorite model provider: open router",
  },
  projects: {
    title1: "Selected",
    title2: "Work",
    range: "(2022 to 2024)",
    count: "{n} projects",
    cta: "let's work together",
    footerTitle: "web master & fullstack developer",
    footerBased: "casablanca",
  },
  project: {
    category: "(category)",
    role: "(role)",
    year: "(year)",
    visit: "visit live site",
    prev: "Previous project",
    next: "Next project",
  },
  about: {
    title1: "About",
    title2: "Me",
    metaRole1: "(web master &",
    metaRole2: "fullstack developer)",
    storyLabel: "(the story so far)",
    storyP1:
      "The first website I built dates back to 2015. What began as simple curiosity quickly turned into an adventure: years of teaching myself web development, e-commerce and digital marketing, one project at a time.",
    storyP2:
      "Today I'm a full-stack developer dedicated to building scalable, accessible and high-performance web solutions. With over three years of full-time freelance experience and a background in agency leadership, I bridge deep technical execution with results-driven digital strategy.",
    servicesLabel: "(services)",
    services: [
      "full-stack development",
      "wordpress development",
      "e-commerce",
      "seo & organic visibility",
      "media buying & social",
      "web maintenance",
    ],
    elsewhereLabel: "(elsewhere)",
    journey: [
      {
        label: "(early career)",
        body: "I honed my development and SEO expertise at the French agencies Comparcom and HorizonCom, where I helped over 80 businesses launch their first websites or undergo complete redesigns, gaining a mastery of WordPress development and organic visibility that set the stage for everything that followed.",
      },
      {
        label: "(a turning point)",
        body: "That foundation led to a pivotal freelance engagement with LAP Electric, one of Morocco's industry leaders. I stepped in to rescue their abandoned development project, slashing page load times from a critical 12 seconds to a lightning-fast 1.2 seconds, while implementing a comprehensive SEO, media buying and social media strategy that now positions them competitively against major rivals like Ingelec and Legrand.",
      },
      {
        label: "(leading teams)",
        body: "Expanding my leadership, I served as Team Manager for a Luxembourg-based marketing agency, directing a cross-functional team of 3 developers and 2 media buyers. I restructured internal workflows and project-handling processes while actively building websites, running ad campaigns, writing SEO articles and resolving complex client and technical escalations.",
      },
      {
        label: "(craft & philosophy)",
        body: "As a full-time freelancer, I've collaborated extensively with Moroccan agencies such as Cactus Agency, delivering custom, design-faithful websites, predominantly for the real estate sector. I deliberately maintain a consistent, reliable tech stack to guarantee quality and continuity, prioritizing durability and full functionality over fleeting trends. My driving philosophy is to engineer digital products that stand the test of time: robust, maintainable and built to last.",
      },
    ],
    getInTouch: "get in touch",
    basedLine1: "based in",
    basedLine2: "casablanca, ma",
  },
  contact: {
    title1: "Get In",
    title2: "Touch",
    meta1: "(no forms,",
    meta2: "just reach out)",
    phone: "(phone)",
    email: "(email)",
    social: "(social)",
    location: "(location)",
    casablanca: "casablanca",
    morocco: "morocco",
    copy: "© 2026",
    footerName: "mounir el majdoub",
  },
  seo: {
    homeDesc:
      "Mounir El Majdoub, web master and fullstack developer based in Casablanca. Portfolio of fast, refined websites and web applications across real estate, corporate, brand and event projects.",
    workTitle: "Selected Work",
    workDesc:
      "Selected web design and development work by Mounir El Majdoub: real estate, corporate, brand and event websites, engineered to be fast, refined and built to last.",
    aboutTitle: "About",
    aboutDesc:
      "Mounir El Majdoub is a web master and fullstack developer based in Casablanca. The story, services and career behind the work.",
    contactTitle: "Contact",
    contactDesc:
      "Get in touch with Mounir El Majdoub, web master and fullstack developer in Casablanca. Email, phone, LinkedIn and Instagram. No forms, just reach out.",
  },
};

const fr = {
  siteName: "Mounir El Majdoub",
  jobTitle: "Web Master & Développeur Fullstack",
  nav: { index: "accueil", work: "projets", about: "à propos", contact: "contact" },
  home: {
    name1: "Mounir",
    name2: "El Majdoub",
    role1: "Web Master",
    role2: "& Développeur",
    basedIn: "basé à",
    casablanca: "casablanca, ma",
    availableFor: "disponible pour",
    freelanceWork: "missions freelance",
    selectedWork: "(projets sélectionnés)",
    viewAllWork: "voir tous les projets",
    aboutLabel: "(à propos)",
    aboutTeaser:
      "Je suis Mounir El Majdoub, web master et développeur fullstack basé à Casablanca. Je conçois et développe des sites et applications web rapides et soignés, des plateformes immobilières et corporate aux sites de marque et d'événement, en gérant tout, du front-end au back-end.",
    email: "e-mail",
    linkedin: "linkedin",
    instagram: "instagram",
    copy: "© 2026",
    footerName: "mounir el majdoub",
    footerTitle: "web master & développeur fullstack",
    footerBased: "casablanca",
  },
  stack: {
    label: "(stack)",
    development: "(développement)",
    ai: "(ia)",
    note: "fournisseur de modèles préféré : open router",
  },
  projects: {
    title1: "Projets",
    title2: "Sélectionnés",
    range: "(2022 à 2024)",
    count: "{n} projets",
    cta: "travaillons ensemble",
    footerTitle: "web master & développeur fullstack",
    footerBased: "casablanca",
  },
  project: {
    category: "(catégorie)",
    role: "(rôle)",
    year: "(année)",
    visit: "voir le site en ligne",
    prev: "Projet précédent",
    next: "Projet suivant",
  },
  about: {
    title1: "À",
    title2: "Propos",
    metaRole1: "(web master &",
    metaRole2: "développeur fullstack)",
    storyLabel: "(le parcours jusqu'ici)",
    storyP1:
      "Le premier site que j'ai créé remonte à 2015. Ce qui a commencé par simple curiosité est vite devenu une aventure : des années à apprendre par moi-même le développement web, l'e-commerce et le marketing digital, un projet à la fois.",
    storyP2:
      "Aujourd'hui, je suis développeur fullstack dédié à la création de solutions web évolutives, accessibles et performantes. Avec plus de trois ans d'expérience en freelance à temps plein et un parcours en direction d'agence, je fais le lien entre l'exécution technique pointue et une stratégie digitale orientée résultats.",
    servicesLabel: "(services)",
    services: [
      "développement fullstack",
      "développement wordpress",
      "e-commerce",
      "seo & visibilité organique",
      "media buying & réseaux sociaux",
      "maintenance web",
    ],
    elsewhereLabel: "(ailleurs)",
    journey: [
      {
        label: "(débuts de carrière)",
        body: "J'ai affiné mon expertise en développement et en SEO au sein des agences françaises Comparcom et HorizonCom, où j'ai aidé plus de 80 entreprises à lancer leur premier site ou à le refondre entièrement, acquérant une maîtrise du développement WordPress et de la visibilité organique qui a posé les bases de tout ce qui a suivi.",
      },
      {
        label: "(un tournant)",
        body: "Cette base m'a mené à une mission freelance décisive avec LAP Electric, l'un des leaders de son secteur au Maroc. Je suis intervenu pour sauver leur projet de développement à l'abandon, réduisant le temps de chargement des pages d'un critique 12 secondes à un fulgurant 1,2 seconde, tout en déployant une stratégie complète de SEO, de media buying et de réseaux sociaux qui les positionne aujourd'hui face à des rivaux majeurs comme Ingelec et Legrand.",
      },
      {
        label: "(gestion d'équipe)",
        body: "En élargissant mes responsabilités, j'ai occupé le poste de Team Manager pour une agence marketing basée au Luxembourg, dirigeant une équipe transverse de 3 développeurs et 2 media buyers. J'ai restructuré les flux de travail internes et la gestion de projet tout en développant activement des sites, en pilotant des campagnes publicitaires, en rédigeant des articles SEO et en résolvant des escalades clients et techniques complexes.",
      },
      {
        label: "(savoir-faire & philosophie)",
        body: "En tant que freelance à temps plein, j'ai collaboré étroitement avec des agences marocaines comme Cactus Agency, livrant des sites sur mesure et fidèles au design, principalement dans le secteur immobilier. Je maintiens délibérément une stack technique cohérente et fiable pour garantir qualité et continuité, en privilégiant la durabilité et la pleine fonctionnalité aux tendances éphémères. Ma philosophie : concevoir des produits digitaux qui traversent le temps, robustes, maintenables et durables.",
      },
    ],
    getInTouch: "me contacter",
    basedLine1: "basé à",
    basedLine2: "casablanca, ma",
  },
  contact: {
    title1: "Me",
    title2: "Contacter",
    meta1: "(pas de formulaire,",
    meta2: "écrivez-moi)",
    phone: "(téléphone)",
    email: "(e-mail)",
    social: "(réseaux)",
    location: "(localisation)",
    casablanca: "casablanca",
    morocco: "maroc",
    copy: "© 2026",
    footerName: "mounir el majdoub",
  },
  seo: {
    homeDesc:
      "Mounir El Majdoub, web master et développeur fullstack basé à Casablanca. Portfolio de sites et applications web rapides et soignés : immobilier, corporate, marque et événementiel.",
    workTitle: "Projets Sélectionnés",
    workDesc:
      "Sélection de projets de conception et développement web de Mounir El Majdoub : sites immobiliers, corporate, de marque et événementiels, pensés pour être rapides, soignés et durables.",
    aboutTitle: "À propos",
    aboutDesc:
      "Mounir El Majdoub est web master et développeur fullstack basé à Casablanca. Le parcours, les services et la carrière derrière le travail.",
    contactTitle: "Contact",
    contactDesc:
      "Contactez Mounir El Majdoub, web master et développeur fullstack à Casablanca. E-mail, téléphone, LinkedIn et Instagram. Pas de formulaire, écrivez-moi.",
  },
};

const ar = {
  siteName: "منير المجدوب",
  jobTitle: "ويب ماستر ومطوّر متكامل",
  nav: { index: "الرئيسية", work: "الأعمال", about: "نبذة", contact: "تواصل" },
  home: {
    name1: "منير",
    name2: "المجدوب",
    role1: "ويب ماستر",
    role2: "ومطوّر",
    basedIn: "مقيم في",
    casablanca: "الدار البيضاء، المغرب",
    availableFor: "متاح لـ",
    freelanceWork: "أعمال حرة",
    selectedWork: "(أعمال مختارة)",
    viewAllWork: "عرض كل الأعمال",
    aboutLabel: "(نبذة)",
    aboutTeaser:
      "أنا منير المجدوب، ويب ماستر ومطوّر متكامل مقيم في الدار البيضاء. أصمّم وأبني مواقع وتطبيقات ويب سريعة ومتقنة، من منصّات العقار والشركات إلى مواقع العلامات التجارية والفعاليات، وأتولّى كل شيء من واجهة المستخدم إلى الخلفية البرمجية.",
    email: "البريد الإلكتروني",
    linkedin: "لينكدإن",
    instagram: "إنستغرام",
    copy: "© 2026",
    footerName: "منير المجدوب",
    footerTitle: "ويب ماستر ومطوّر متكامل",
    footerBased: "الدار البيضاء",
  },
  stack: {
    label: "(الأدوات)",
    development: "(التطوير)",
    ai: "(الذكاء الاصطناعي)",
    note: "مزوّد النماذج المفضّل: open router",
  },
  projects: {
    title1: "أعمال",
    title2: "مختارة",
    range: "(2022 إلى 2024)",
    count: "{n} مشاريع",
    cta: "لنعمل معًا",
    footerTitle: "ويب ماستر ومطوّر متكامل",
    footerBased: "الدار البيضاء",
  },
  project: {
    category: "(الفئة)",
    role: "(الدور)",
    year: "(السنة)",
    visit: "زيارة الموقع",
    prev: "المشروع السابق",
    next: "المشروع التالي",
  },
  about: {
    title1: "نبذة",
    title2: "عني",
    metaRole1: "(ويب ماستر",
    metaRole2: "ومطوّر متكامل)",
    storyLabel: "(القصة حتى الآن)",
    storyP1:
      "يعود أول موقع أنشأته إلى عام 2015. ما بدأ فضولًا بسيطًا سرعان ما تحوّل إلى مغامرة: سنوات من تعليم نفسي تطوير الويب والتجارة الإلكترونية والتسويق الرقمي، مشروعًا تلو الآخر.",
    storyP2:
      "اليوم أنا مطوّر متكامل مكرّس لبناء حلول ويب قابلة للتوسّع وسهلة الوصول وعالية الأداء. بخبرة تتجاوز ثلاث سنوات من العمل الحر بدوام كامل وخلفية في قيادة الوكالات، أصل بين التنفيذ التقني العميق والاستراتيجية الرقمية الموجّهة نحو النتائج.",
    servicesLabel: "(الخدمات)",
    services: [
      "تطوير متكامل",
      "تطوير ووردبريس",
      "التجارة الإلكترونية",
      "السيو والظهور الطبيعي",
      "شراء الإعلانات والتواصل الاجتماعي",
      "صيانة المواقع",
    ],
    elsewhereLabel: "(في أماكن أخرى)",
    journey: [
      {
        label: "(بداية المسيرة)",
        body: "صقلت خبرتي في التطوير والسيو لدى الوكالتين الفرنسيتين Comparcom وHorizonCom، حيث ساعدت أكثر من 80 شركة على إطلاق موقعها الأول أو إعادة تصميمه بالكامل، واكتسبت إتقانًا لتطوير ووردبريس والظهور الطبيعي مهّد الطريق لكل ما تلا ذلك.",
      },
      {
        label: "(نقطة تحوّل)",
        body: "قادني هذا الأساس إلى مهمة حرة محورية مع LAP Electric، أحد روّاد قطاعها في المغرب. تدخّلت لإنقاذ مشروع التطوير المتوقّف لديهم، فخفّضت زمن تحميل الصفحات من 12 ثانية حرجة إلى 1.2 ثانية خاطفة، مع تنفيذ استراتيجية شاملة للسيو وشراء الإعلانات والتواصل الاجتماعي تجعلهم اليوم في منافسة قوية مع كبار المنافسين مثل Ingelec وLegrand.",
      },
      {
        label: "(قيادة الفرق)",
        body: "توسيعًا لمسؤولياتي، عملت مديرًا لفريق في وكالة تسويق مقرّها لوكسمبورغ، أقود فريقًا متعدّد التخصّصات من 3 مطوّرين واثنين من مشتري الإعلانات. أعدت هيكلة سير العمل الداخلي وإدارة المشاريع، مع بناء المواقع بنشاط وإدارة الحملات الإعلانية وكتابة مقالات السيو وحل التصعيدات التقنية والعميلة المعقّدة.",
      },
      {
        label: "(الحرفة والفلسفة)",
        body: "بصفتي مستقلًّا بدوام كامل، تعاونت على نطاق واسع مع وكالات مغربية مثل Cactus Agency، مقدّمًا مواقع مخصّصة وأمينة للتصميم، غالبًا في قطاع العقار. أحافظ عمدًا على حزمة تقنية ثابتة وموثوقة لضمان الجودة والاستمرارية، مفضّلًا المتانة والوظيفية الكاملة على الاتجاهات العابرة. فلسفتي: هندسة منتجات رقمية تصمد أمام الزمن، متينة وقابلة للصيانة وطويلة الأمد.",
      },
    ],
    getInTouch: "تواصل معي",
    basedLine1: "مقيم في",
    basedLine2: "الدار البيضاء، المغرب",
  },
  contact: {
    title1: "تواصل",
    title2: "معي",
    meta1: "(لا نماذج،",
    meta2: "راسلني مباشرة)",
    phone: "(الهاتف)",
    email: "(البريد)",
    social: "(التواصل)",
    location: "(الموقع)",
    casablanca: "الدار البيضاء",
    morocco: "المغرب",
    copy: "© 2026",
    footerName: "منير المجدوب",
  },
  seo: {
    homeDesc:
      "منير المجدوب، ويب ماستر ومطوّر متكامل مقيم في الدار البيضاء. أعمال في مواقع وتطبيقات ويب سريعة ومتقنة: عقار، شركات، علامات تجارية وفعاليات.",
    workTitle: "أعمال مختارة",
    workDesc:
      "مجموعة مختارة من أعمال تصميم وتطوير الويب لمنير المجدوب: مواقع عقارية وشركاتية وعلامات تجارية وفعاليات، مبنية لتكون سريعة ومتقنة وطويلة الأمد.",
    aboutTitle: "نبذة",
    aboutDesc:
      "منير المجدوب ويب ماستر ومطوّر متكامل مقيم في الدار البيضاء. القصة والخدمات والمسيرة وراء العمل.",
    contactTitle: "تواصل",
    contactDesc:
      "تواصل مع منير المجدوب، ويب ماستر ومطوّر متكامل في الدار البيضاء. البريد الإلكتروني والهاتف ولينكدإن وإنستغرام. لا نماذج، راسلني مباشرة.",
  },
};

const translations = { en, fr, ar };
export default translations;
